import { render, staticRenderFns } from "./secondIndex.vue?vue&type=template&id=30bb09e4&scoped=true&"
import script from "./secondIndex.vue?vue&type=script&lang=js&"
export * from "./secondIndex.vue?vue&type=script&lang=js&"
import style0 from "./secondIndex.vue?vue&type=style&index=0&id=30bb09e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bb09e4",
  null
  
)

export default component.exports